import { KeyValue } from '@angular/common';
import { SortDirection } from './table-sort-options/table-sort-options.component';
import { WhereFilterOp } from 'firebase/firestore';

export interface GridPreferences {
  filter?: string;
  displayMode?: string;
  displayedDocs?: string[];

  filters?: KeyValue<string, any>[];
  filtersOps?: { field: string; op: WhereFilterOp; value: any }[];
  itemsSort?: KeyValue<string, SortDirection>[];
  itemsStartsAt?: number;
  itemsPerPage?: number;
}

/*
 * voir "window"
 * https://material.io/design/layout/responsive-layout-grid.html#breakpoints
 */
export interface GridHeader {
  name?: string;
  minScreenSize?: string;
}

export function isFilteredBy(prefs: GridPreferences, key: string): boolean {
  return filteredIndex(prefs, key) !== -1;
}

export function filteredIndex(prefs: GridPreferences, val: string): number {
  let valInx = -1;
  if (prefs.filters) {
    prefs.filters.forEach((filter: KeyValue<string, string>, inx: number) => {
      if (filter.key === val) {
        valInx = inx;
      }
    });
  }

  return valInx;
}

export function filteredValue(prefs: GridPreferences, filter: string, defaultVal: any = null): any {
  let valInx = -1;

  if (prefs?.filters) {
    prefs.filters.forEach((filterKeyVal: KeyValue<string, any>, inx: number) => {
      if (filterKeyVal.key === filter) {
        valInx = inx;
      }
    });
  }

  return valInx !== -1 ? prefs.filters[valInx].value : defaultVal;
}

export function isSortedBy(prefs: GridPreferences, val: string): boolean {
  return sortIndex(prefs, val) !== -1;
}

export function sortIndex(prefs: GridPreferences, val: string): number {
  let valInx = -1;

  if (prefs.itemsSort) {
    prefs.itemsSort.forEach((sort: KeyValue<string, SortDirection>, inx: number) => {
      if (sort.key === val) {
        valInx = inx;
      }
    });
  }

  return valInx;
}

export function toQueryFilter(prefs: GridPreferences): any {
  const filters = {};
  if (prefs.filters) {
    prefs.filters.forEach((s: KeyValue<string, any>) => {
      const keyValue = s.value;
      const valueIsAnArray = Array.isArray(keyValue);

      if (valueIsAnArray && keyValue.length > 0) {
        filters[s.key] = keyValue;
      } else if (keyValue !== null && keyValue !== undefined && !valueIsAnArray) {
        filters[s.key] = keyValue;
      }
    });
  }
  return filters;
}
